require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-meet-erik-from-puzzle-master-to-software-developer.json") })
        }
      }, "path---blog-meet-erik-from-puzzle-master-to-software-developer");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-meet-erik-from-puzzle-master-to-software-developer!./.cache/json/blog-meet-erik-from-puzzle-master-to-software-developer.json
// module id = 948
// module chunks = 231608221292675